import { useMutation, useQueryClient } from '@tanstack/react-query';
import taskTemplateService from '@services/taskTemplate';
import { toast } from 'react-toastify';
import { TaskTemplateImportInput } from '@models/taskTemplate.model';
import { useTranslation } from '@hooks/useTranslation';

export const useImportTaskTemplate = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['importTaskTemplate'],
    mutationFn: async (input: TaskTemplateImportInput) => {
      return await taskTemplateService.importTaskTemplate(input);
    },
    onSuccess: async () => {
      toast.success(tActionMessages.tasksImportedSuccessfully);
      await queryClient.invalidateQueries({ queryKey: ['tasks'] });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message ||
          error?.message ||
          tActionMessages.failedToImportTasksFromTemplate,
      );
    },
  });
};

export default useImportTaskTemplate;
